/* External */
import axios from "axios";

/* Others */
import { STATIC_URLS, getURLWithParams } from "./../../utils/urls/index";

export const getConfigurationFromAEM = () => {
  return axios.get(getURLWithParams(STATIC_URLS.AEM.mobileConfig));
};
